const Cart = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.67747 14.1742C6.23028 14.1742 6.67842 13.726 6.67842 13.1732C6.67842 12.6204 6.23028 12.1723 5.67747 12.1723C5.12466 12.1723 4.67651 12.6204 4.67651 13.1732C4.67651 13.726 5.12466 14.1742 5.67747 14.1742Z"
      fill="black"
    />
    <path
      d="M12.6806 14.1742C13.2335 14.1742 13.6816 13.726 13.6816 13.1732C13.6816 12.6204 13.2335 12.1723 12.6806 12.1723C12.1278 12.1723 11.6797 12.6204 11.6797 13.1732C11.6797 13.726 12.1278 14.1742 12.6806 14.1742Z"
      fill="black"
    />
    <path
      d="M14.4544 3.94526C14.3841 3.85932 14.2956 3.79011 14.1953 3.74264C14.0949 3.69517 13.9853 3.67064 13.8743 3.67083H4.36127L4.16966 2.58372C4.14923 2.46792 4.08865 2.36302 3.99857 2.28745C3.90848 2.21189 3.79464 2.17048 3.67706 2.1705H1.67662C1.54399 2.1705 1.41678 2.22319 1.32299 2.31698C1.2292 2.41077 1.17651 2.53797 1.17651 2.67061C1.17651 2.80325 1.2292 2.93045 1.32299 3.02424C1.41678 3.11803 1.54399 3.17072 1.67662 3.17072H3.25759L4.68478 11.2594C4.70521 11.3752 4.76579 11.4801 4.85588 11.5556C4.94596 11.6312 5.0598 11.6726 5.17738 11.6726H13.1791C13.3118 11.6726 13.439 11.6199 13.5328 11.5261C13.6265 11.4323 13.6792 11.3051 13.6792 11.1725C13.6792 11.0398 13.6265 10.9126 13.5328 10.8188C13.439 10.725 13.3118 10.6724 13.1791 10.6724H5.59685L5.42056 9.67214H12.9741C13.1475 9.67192 13.3155 9.61178 13.4497 9.50191C13.5839 9.39204 13.676 9.23917 13.7105 9.06919L14.6107 4.56821C14.6324 4.45928 14.6296 4.3469 14.6026 4.23917C14.5756 4.13144 14.5249 4.03105 14.4544 3.94526Z"
      fill="black"
    />
  </svg>
);

export default Cart;
